module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/path.js
// module id = 56
// module chunks = 1